<!--  -->
<template>
  <div>
        <!-- Course Start -->
        <section class="popular-course-section-2">
            <div class="container">
                <div class="row">
                    <div class="col-md-12 text-center">
                        <h2 class="sec-title mb-15">认证 ● 培训 ● 考试</h2>
                        <p class="sec-desc">
                            在线教育是一个灵活的教学交付系统，包括通过<br> 互联网进行的任何类型的学习。
                        </p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-3 col-md-6">
                        <div class="course-item-2 text-center">
                            <div class="course-thumb">
                                <img src="/static/images/home2/popular-course/1.png" alt="">
                            </div>
                            <h4><router-link :to="`/views/${plateid}`" >名师简介</router-link></h4>
                            <p>全国名校名师信息介绍</p>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6">
                        <div class="course-item-2 text-center">
                            <div class="course-thumb">
                                <img src="/static/images/home2/popular-course/2.png" alt="">
                            </div>
                            <h4> <router-link to="/courviews">课程简介</router-link></h4>
                            <p>高质量课程在线视频</p>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6">
                        <div class="course-item-2 text-center">
                            <div class="course-thumb">
                                <img src="/static/images/home2/popular-course/3.png" alt="">
                            </div>
                            <h4><router-link to="/papercenter">试卷中心</router-link></h4>
                            <p>多种专业考试</p>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6">
                        <div class="course-item-2 text-center">
                            <div class="course-thumb">
                                <img src="/static/images/home2/popular-course/4.png" alt="">
                            </div>
                            <h4><router-link to="/liveview">在线直播</router-link></h4>
                            <p>名师直播，帮你快速通关</p>
                        </div>
                    </div>
                </div>

            </div>
        </section>
        <!-- Course End -->
  </div>
</template>

<script>
import global from "@/components/PublicComs/Common.vue";
export default {
  data () {
    return {
        plateid:"",
        global
    };
  },
  props: {
    plates:Array
  },
  components: {},

  computed: {},

  mounted() {
    for (var i = 0; i < this.plates.length; i++) {
        if(this.plates[i].name=="名师简介"){
            this.plateid = this.plates[i]._id;
        }
    }
  },

  methods: {}
}

</script>
<style scoped>
    .cls-1 {
                                            fill: url(#pattern);
                                        }
</style>